import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { storeFreeze } from 'ngrx-store-freeze';
import { reducers } from './app/shared/ngrx';
import { StoreModule, MetaReducer } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { CustomLocale } from './app/shared/enums/language-code.enum';
import { provideHttpClient } from '@angular/common/http';

const metaReducers: MetaReducer<any>[] = !environment.production
  ? [storeFreeze]
  : [];

if (environment.production) {
  enableProdMode();
}

/**
 * Used by DatePipe, CurrencyPipe, DecimalPipe, PercentPipe (Angular)
 * @link https://angular.dev/guide/i18n/format-data-locale
 * @link https://angular.dev/guide/i18n/import-global-variants#import-example-for-french
 * @param lang
 */
for (let lang of Object.values(CustomLocale)) {
  import(
    /* webpackExclude: /\.d\.ts$/ */
    /* webpackMode: "lazy-once" */
    /* webpackChunkName: "i18n-extra" */
    `../node_modules/@angular/common/locales/${lang}.mjs`
  ).then((module) => registerLocaleData(module.default));
}

async function initializeWorker() {
  if (environment.mock) {
    const { worker } = await import('./app/shared/apis/mocks/browser');
    return worker.start({
      onUnhandledRequest: 'warn',
    });
  }
  return Promise.resolve();
}

initializeWorker().then(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(
        // Angular Modules
        BrowserModule,

        // Custom Modules
        AppRoutingModule,

        // Misc Modules
        TranslateModule.forRoot(),

        // Ngrx Modules
        StoreModule.forRoot(reducers, { metaReducers }),
        StoreDevtoolsModule.instrument({
          maxAge: 25,
          logOnly: environment.production,
          connectInZone: true,
        }),
        StoreRouterConnectingModule.forRoot(),
      ),
      DatePipe,
      CurrencyPipe,
      provideAnimations(),
      provideHttpClient(),
    ],
  }).catch((err) => console.error(err));
});
